import React from 'react';

function UnsubscribeModal({ isOpen, creatorName, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-card shadow-2xl max-w-md w-full p-6">
        <h3 className="text-xl font-heading font-bold mb-3">Unsubscribe from {creatorName}?</h3>
        <p className="text-gray-600 mb-2">Are you sure you want to unsubscribe? You will:</p>
        <ul className="text-sm text-gray-600 mb-6 space-y-1 list-disc pl-5">
          <li>Lose access to their reviews in your feed</li>
          <li>All saved reviews from this creator will be removed</li>
          <li>Your subscription benefits will end immediately</li>
        </ul>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-3 border-2 border-gray-300 rounded-button font-semibold hover:bg-gray-50"
            data-testid="cancel-unsubscribe"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 bg-red-500 text-white px-4 py-3 rounded-button font-semibold hover:bg-red-600"
            data-testid="confirm-unsubscribe"
          >
            Unsubscribe
          </button>
        </div>
      </div>
    </div>
  );
}

export default UnsubscribeModal;
